import { api } from 'api';
import { UserInformation } from 'common/state/auth/actions';
import { getErrorMessage } from 'common/utils/requestErrorHandling';
import { Notification } from './actions';

interface NotificationRequest {
  count: number;
  next: string;
  previous: string;
  results: Notification[];
}

/**
 * Retrieves pending notifications
 */
export const doRetrieveNotifications = () => async (dispatch) => {
  dispatch({ type: 'notification/retrieve/started' });

  try {
    // Limit by 1000 to get every notification (hopefully)
    const response = await api.get<NotificationRequest>('/notification/', {
      params: { status: 'new', limit: 1000 },
    });
    dispatch({
      type: 'notification/retrieve/finished',
      notifications: response.data.results,
    });
  } catch (e) {
    dispatch({
      type: 'notification/retrieve/finished',
      error: 'Unable to retrieve notifications',
    });
  }
};

/**
 * Removes an existing Notification
 * @param id The notification id
 */
export const doRemoveNotification = (id: number) => async (dispatch) => {
  dispatch({ type: 'notification/remove/started' });

  try {
    await api.patch<Notification>('/notification/' + id + '/', {
      status: 'ack',
    });
    dispatch({
      type: 'notification/remove/finished',
      success: true,
    });
  } catch (e) {
    dispatch({
      type: 'notification/remove/finished',
      success: false,
      error: 'Unable to remove notification',
    });
  }
};

/**
 * Sends a recovery link to the email belonging to the account via their username or e-mail
 * @param email
 */
export const doUpdateEmail = (email: string) => async (dispatch) => {
  dispatch({ type: 'self/email/update/started' });

  try {
    await api.patch<UserInformation>('/contact/self/', {
      email,
    });
    dispatch({
      type: 'self/email/update/finished',
      success: true,
    });
  } catch (e) {
    dispatch({
      type: 'self/email/update/finished',
      success: false,
      error: getErrorMessage(e.response.data),
    });
  }
};

/**
 * Sends a recovery link to the email belonging to the account via their username or e-mail
 * @param newPassword
 * @param oldPassword
 */
export const doUpdatePassword =
  (newPassword: string, oldPassword: string) => async (dispatch) => {
    dispatch({ type: 'self/password/update/started' });

    try {
      await api.post<UserInformation>('/contact/self/change_password/', {
        old_password: oldPassword,
        password: newPassword,
      });
      dispatch({
        type: 'self/password/update/finished',
        success: true,
      });
    } catch (e) {
      dispatch({
        type: 'self/password/update/finished',
        success: false,
        error: getErrorMessage(e.response.data),
      });
    }
  };
